import React, { useEffect, useState } from 'react';
import MainHeader from '../../components/mainheader/MainHeader'
import AuthorProfilePage from '../authorprofilepage/AuthorProfilePage'
import logo from '../../../assets/images/brandlogo.png'
import mainindexStyle from './MainIndexPage.module.css'
import benefitone from '../../../assets/images/lady-img.png';
import benefittwo from '../../../assets/images/men-img.png';
import benefitthree from '../../../assets/images/study-img.png';
import { useMediaQuery } from 'react-responsive';
import { FaFacebookF } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaPinterest } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaUser } from "react-icons/fa6";
import { GoGlobe } from "react-icons/go";
import { Link } from 'react-router-dom';
import { IoSearch } from "react-icons/io5";
import { IoShareOutline } from "react-icons/io5";
import { FaHeart } from "react-icons/fa";
import { CheckPicker } from 'rsuite';
import { useNavigate } from "react-router-dom";
import axios from "axios";
require('typeface-poppins')

export default function MainIndexPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [category, setCategory] = useState([]);
  const [genre, setGenre] = useState([]);
  const [region, setRegion] = useState([]);
  const [category1, setCategory1] = useState([]);
  const [genre1, setGenre1] = useState([]);
  const [region1, setRegion1] = useState([]);
  const [query1, setQuery] = useState([]);
  const [items, setItems] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const navigate = useNavigate();
  const [zipCode, setZipCode] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await axios.get('http://www.bookwormtest.com/authormeetapi/get_author_data_all.php');
        //const response = await axios.get('https://www.authormeet.net/authormeetapi/get_author_data_all.php');

        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all.php`);

        // console.log("response", response);

        if (response.data.success) {
          setUsers(response.data.users);
          setGenre1([{ 0: "Any", genre_name: "Any" }, ...response.data.genres]);
          setRegion1(response.data.regions);
          setCategory1(response.data.categories);
          setLoading(false);
          setFilteredUsers(response.data.users);

        }
        else {
          setLoading(false);
        }
        // Initialize filtered users to all users
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Combine the three states into one array and update the items state
    setItems([category1, genre1, region1]);
  }, [category1, genre1, region1]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const handleGenreChange = (value) => {
    // Check if "Any" is being toggled
    const isAnySelected = value.includes("Any");
    const wasAnySelected = selectedGenres.includes("Any");

    if (isAnySelected && !wasAnySelected) {
      // If "Any" is being selected, select all genres
      const allGenres = genre1
        .filter(genre => genre.genre_name !== "Any")
        .map(genre => genre.genre_name);
      setSelectedGenres([...allGenres, "Any"]);
    } else if (!isAnySelected && wasAnySelected) {
      // If "Any" is being deselected, deselect all genres
      setSelectedGenres([]);
    } else {
      // Handle individual selections/deselections
      if (value.length === 0) {
        setSelectedGenres([]);
      } else {
        // If all items except one are deselected, keep the selection
        setSelectedGenres(value);
      }
    }
  };

  const handleCategoryChange = (value) => {
    setSelectedCategories(value);
  };

  const handleRegionChange = (value) => {
    setSelectedRegions(value);
  };

  const handleSearch = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/filterdata.php`, {
        genres: JSON.stringify(selectedGenres),
        categories: JSON.stringify(selectedCategories),
        regions: JSON.stringify(selectedRegions),
        query: query1 || ""
      });
      if (response.data.success) {
        setFilteredUsers(response.data.users);
        //console.log(response.data.query); 
        navigate('/ResultSearchingPage', {
          state: { users: response.data.users }
        });

      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleSearch1 = async (query1) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/filterauthor.php`, {
        params: { query1 }
      });
      if (response.data.success) {
        setFilteredUsers(response.data.users);
      }
      else {
        //setFilteredUsers(false);
      }
    } catch (err) {
      console.error(err);
    }
  }

  const genreArr = genre1.map((item) => item.genre_name)
  const genredata = genreArr.map(
    item => ({ label: item, value: item })
  );

  const categoryArr = category1.map((item) => item.category_name)
  const categorydata = categoryArr.map(
    item => ({ label: item, value: item })
  );

  const regionArr = region1.map((item) => item.region_name)
  const regiondata = regionArr.map(
    item => ({ label: item, value: item })
  );

  return (
    <>
      <MainHeader onSearch={handleSearch1} />
      <div className={mainindexStyle.mainindexpage}>

        {isMobile ? (
          <div className={mainindexStyle.mobilmainbannerPart}>
            <div className='container'>
              <div className='row justify-content-center'>
                <div className='col-lg-8'>
                  <div className={mainindexStyle.mobilmainbannerContent}>
                    <div className={mainindexStyle.mobilmainbannertextPart}>
                      <h5>Connect with the voices behind the stories</h5>
                      <p> Host unforgettable events with authors from a wide range of genres and backgrounds.
                        Start exploring today and bring stories to life for your audience. </p>
                    </div>
                    <div className={mainindexStyle.mobilmainbannerbar}>
                      <h4> Search By: </h4>
                      <form onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
                        <div className={mainindexStyle.mobilmainbannerInputs}>
                          <div className='row g-0'>
                            <div className='col-3'>
                              <CheckPicker className='MobileSelectbar w-100 h-100' onChange={handleGenreChange} name='genres' value={selectedGenres} data={genredata} searchable={false} style={{ width: '100%' }} placeholder="Genre" />
                            </div>
                            <div className='col-3'>
                              <CheckPicker className='MobileSelectbar w-100 h-100' onChange={handleCategoryChange} name='categories' value={selectedCategories} data={categorydata} searchable={false} style={{ width: '100%' }} placeholder="Age Groups" />
                            </div>
                            {/* <div className='col-3'>
                              <CheckPicker className='MobileSelectbar w-100 h-100' onChange={handleRegionChange} name='regions' value={selectedRegions} data={regiondata} searchable={false} style={{ width: '100%' }} placeholder="Your Region" />
                            </div> */}
                            <div className='col-3'>
                              <input
                                type="text"
                                className={`${mainindexStyle.DesktopSelectbarZipCode} w-100 h-100 ${mainindexStyle.zipCode}`}
                                name='zipcode'
                                value={zipCode}
                                onChange={(e) => {
                                  let value = e.target.value.replace(/\D/g, '');
                                  if (value.length > 5) {
                                    value = value.slice(0, 5);
                                  }
                                  setZipCode(value);
                                }}
                                placeholder="Your Zip Code"
                              />
                            </div>
                            <div className='col-3'>
                              <div className={`${mainindexStyle.mobilemainbannerButtonbox} d-flex align-items-center justify-content-center h-100`}>
                                <button className={`${mainindexStyle.mobilmainsearchButton} d-flex align-items-center justify-content-center btn btn-warning`} type="submit">
                                  <IoSearch className={mainindexStyle.mobilmainserachIcon} />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={mainindexStyle.DesktopmainbannerPart}>
            <div className='container'>
              <div className='row justify-content-center'>
                <div className='col-lg-8'>
                  <div className={mainindexStyle.DesktopmainbannerContent}>
                    <div className={mainindexStyle.DesktopmainbannertextPart}>
                      <h5>Connect with the voices behind the stories</h5>
                      <p> Host unforgettable events with authors from a wide range of genres and backgrounds.
                        Start exploring today and bring stories to life for your audience.
                      </p>
                    </div>
                    <div className={mainindexStyle.DesktopmainbannerInputs}>
                      <form onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
                        <div className='row g-0'>
                          <div className='col-lg-3'>
                            <CheckPicker className='DesktopSelectbar w-100 h-100' onChange={handleGenreChange} name='genres' value={selectedGenres} data={genredata} searchable={false} placeholder="Genre" />
                          </div>
                          <div className='col-lg-3'>
                            <CheckPicker className='DesktopSelectbar w-100 h-100' onChange={handleCategoryChange} name='categories' value={selectedCategories} data={categorydata} searchable={false} placeholder="Age Groups" />
                          </div>
                          {/* <div className='col-lg-3'>
                          <CheckPicker className='DesktopSelectbar w-100 h-100' onChange={handleRegionChange} name='regions' value={selectedRegions} data={regiondata} searchable={false} placeholder="Your Region" />         
                          
                        </div>  */}

                          <div className='col-lg-3'>
                            <input
                              type="text"
                              className={`${mainindexStyle.DesktopSelectbarZipCode} w-100 h-100 ${mainindexStyle.zipCode}`}
                              name='zipcode'
                              value={zipCode}
                              onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, '');
                                if (value.length > 5) {
                                  value = value.slice(0, 5);
                                }
                                setZipCode(value);
                              }}
                              placeholder="Your Zip Code"
                            />
                          </div>

                          <div className='col-lg-3'>
                            <div className={mainindexStyle.DesktopmainbannerButtonbox}>
                              <button className={`${mainindexStyle.DesktopmainbannerButton} btn btn-warning w-100`} type="submit">Search</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 
      {isMobile ? (
        <div className={mainindexStyle.mobilauthorpart}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <h4 className={mainindexStyle.mobilauthorpartTitle}>Top Authors for Events</h4>     
              </div>
            </div>
            <div className='row g-3'>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user, index) => (
              <div key={index} className='col-xl-12 col-lg-12'>
                <div className={mainindexStyle.mobilauthorsBoxes}>
                  <div className="row">
                    <div className='col-3 px-2'>
                      <div className={mainindexStyle.mobilauthorImagebox}>
                        <img src={`http://www.bookwormtest.com/authormeetapi/images/author/${user.author_id}`} className={`${mainindexStyle.mobilauthorImage} img-fluid`} /> 
                      </div>
                    </div>
                    <div className='col-4 px-1'>
                      <div className={mainindexStyle.mobilauthorInformation}>
                        <h6 className={mainindexStyle.mobilauthorinfoTitle}> {user.f_name} {user.l_name} </h6>
                        <div className={mainindexStyle.mobilauthorInfo}> 
                          <span> Willing to Travel? </span>&nbsp; {user.willingtotravel}
                        </div>
                        <div className={`${mainindexStyle.mobilauthorInfo} pb-0`}> 
                          <span> Region: </span>&nbsp; {user.region}
                        </div>
                      </div>
                    </div>
                    <div className='col-5 px-1'>
                      <div className={mainindexStyle.mobilauthorInformation}>
                        <div className={`${mainindexStyle.mobilauthorIcons} d-flex flex-wrap`}>
                          <Link to={`/AuthorProfilePage/${user.author_id}`} element={<AuthorProfilePage />}>
                            <FaUser className={`${mainindexStyle.mobilauthorAuthorary} me-3`} />
                          </Link>
                          {user.website && (
                          <Link to={user.website.startsWith('http') ? user.website : `https://${user.website}`} target="_blank" rel="noopener noreferrer">
                            <GoGlobe className={`${mainindexStyle.mobilauthorAuthorary} me-3`} />
                          </Link>
                          )}
                          <Link> <IoShareOutline className={`${mainindexStyle.mobilauthorAuthorary} me-3`} /> </Link>
                          <Link> <FaHeart className={`${mainindexStyle.mobilauthorAuthorary} me-3`} /> </Link>
                        </div>
                        <div className={mainindexStyle.mobilauthorInfo}> 
                          <span> Category: </span>&nbsp; {user.category}
                        </div>
                        <div className={`${mainindexStyle.mobilauthorInfo} pb-0`}> 
                          <span> Genre: </span>&nbsp; {user.genre}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className='col-12'>
                      <p className={mainindexStyle.mobilauthorBiographytxt}> {user.biography} </p>
                    </div>
                  </div>    
                </div>  
              </div>
              ))
              ) : (
              <div className={mainindexStyle.MobilauthornoAuthorFind}>No authors found based on the filters.</div>
              )}            
            </div>
          </div>
        </div>  
        ) : (
        <div className={mainindexStyle.Desktopauthorpart}>  
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <h4 className={mainindexStyle.DesktopauthorpartTitle}>Top Authors for Events</h4>  
              </div>
            </div>
            <div className='row g-3'>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user, index) => (
                <div key={index} className='col-xl-6 col-lg-6'>
                  <div className={mainindexStyle.DesktopauthorsBoxes}>
                    <div className="row">
                      <div className='col-sm-3 px-2'>
                        <div className={mainindexStyle.DesktopauthorImagebox}>
                          <img src={`http://www.bookwormtest.com/authormeetapi/images/author/${user.author_id}`} className={`${mainindexStyle.DesktopauthorImage} img-fluid`} /> 
                        </div>
                      </div>
                      <div className='col-sm-6 px-2'>
                        <div className={mainindexStyle.DesktopauthorDescription}>
                          <h4>{user.f_name} {user.l_name}</h4>
                          <p>{user.biography}</p>
                        </div>
                      </div>  
                      <div className='col-sm-3 px-1'>
                        <div className={mainindexStyle.DesktopauthorInformation}>
                          <div className={`${mainindexStyle.DesktopauthorIcons} d-flex flex-wrap`}>
                            <Link to={`/AuthorProfilePage/${user.author_id}`} element={<AuthorProfilePage />}>
                              <FaUser className={`${mainindexStyle.DesktopauthorAuthorary} me-3`} />
                            </Link>
                            {user.website && (
                            <Link to={user.website.startsWith('http') ? user.website : `https://${user.website}`} target="_blank" rel="noopener noreferrer">
                              <GoGlobe className={`${mainindexStyle.DesktopauthorAuthorary} me-3`} />
                            </Link>
                            )}                               
                          </div>
                          <div className={mainindexStyle.DesktopauthorInfo}>
                            <span>Willing to Travel? </span>&nbsp; {user.willingtotravel}
                          </div>    
                          <div className={mainindexStyle.DesktopauthorInfo}>
                            <span>Region: </span>&nbsp; {user.region}
                          </div>
                          <div className={mainindexStyle.DesktopauthorInfo}>
                            <span>Category: </span>&nbsp; {user.category}
                          </div>
                          <div className={mainindexStyle.DesktopauthorInfo}>
                            <span>Genre: </span>&nbsp; {user.genre}
                          </div>
                        </div>
                      </div>  
                    </div>
                  </div>
                </div>))
              ) : (
              <div className={mainindexStyle.DesktopauthornoAuthorFind}>No authors found based on the filters.</div>
              )}
            </div>
          </div>
        </div>  
      )} 
      */}


        {isMobile ? (
          <div className={mainindexStyle.mobilmainbenefitpart}>
            <div className='container'>
              {/*<hr /> */}
              <div className='row'>
                <div className='col-lg-12'>
                  <h4 className={mainindexStyle.mobilmainbenefitpartTitle}>Who Can Benefit from AuthorMeet? </h4>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-12'>
                  <div className={mainindexStyle.mobilmainbenefitBoxes}>
                    <div className='row'>
                      <div className='col-5'>
                        <div className={mainindexStyle.mobilmainbenefitimageBox}>
                          <img src={benefitone} className={`${mainindexStyle.mobilmainbenefitimage} img-fluid`} />
                        </div>
                      </div>
                      <div className='col-7'>
                        <div className={mainindexStyle.mobilmainbenefitContent}>
                          <h5> Event Hosts </h5>
                          <h6> Engage Your Audience with Captivating Author Events </h6>
                          <p> Event hosts can easily find the perfect author for their next gathering, whether it's for a book reading, writing seminar,
                            or virtual discussion. AuthorMeet connects you with top authors who are ready to inspire, educate, and entertain your audience.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12'>
                  <div className={mainindexStyle.mobilmainbenefitBoxes}>
                    <div className='row'>
                      <div className='col-7'>
                        <div className={mainindexStyle.mobilmainbenefitContent}>
                          <h5> Authors </h5>
                          <h6> Expand Your Reach and Connect with Readers </h6>
                          <p> Authors can promote their work, share new releases, and engage with a wide range of audiences through AuthorMeet.
                            Whether you're offering workshops, virtual Q&A sessions, or live readings, the platform provides a seamless way to
                            connect with event hosts and interact with readers.
                          </p>
                        </div>
                      </div>
                      <div className='col-5'>
                        <div className={mainindexStyle.mobilmainbenefitimageBox}>
                          <img src={benefittwo} className={`${mainindexStyle.mobilmainbenefitimage} img-fluid`} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12'>
                  <div className={mainindexStyle.mobilmainbenefitBoxes}>
                    <div className='row'>
                      <div className='col-5'>
                        <div className={mainindexStyle.mobilmainbenefitimageBox}>
                          <img src={benefitthree} className={`${mainindexStyle.mobilmainbenefitimage} img-fluid`} />
                        </div>
                      </div>
                      <div className='col-7'>
                        <div className={mainindexStyle.mobilmainbenefitContent}>
                          <h5> Publishers </h5>
                          <h6> Empower Your Authors with New Opportunities </h6>
                          <p> Publishers can leverage AuthorMeet to connect their authors with event hosts, increasing visibility and book sales.
                            Our platform makes it easy to facilitate speaking engagements, allowing your authors to build stronger connections
                            with their audience.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={mainindexStyle.Desktopbenefitpart}>
            <div className='container'>
              {/*<hr /> */}
              <div className='row'>
                <div className='col-lg-12'>
                  <h4 className={mainindexStyle.DesktopbenefitpartTitle}>Who Can Benefit from AuthorMeet? </h4>
                </div>
              </div>
              <div className='row'>
                <div className='col-xl-4 col-lg-4'>
                  <div className={mainindexStyle.DesktopbenefitBoxes}>
                    <div className={mainindexStyle.DesktopbenefitimageBox}>
                      <img src={benefitone} className={`${mainindexStyle.DesktopbenefitImage} w-100 h-100`} />
                    </div>
                    <div className={mainindexStyle.DesktopbenefitContent}>
                      <h5> Event Hosts </h5>
                      <h6> Engage Your Audience with Captivating Author Events </h6>
                      <p>Event hosts can easily find the perfect author for their next gathering, whether it's for a book reading, writing seminar, or virtual discussion. AuthorMeet connects you with top authors who are ready to inspire, educate, and entertain your audience.</p>
                    </div>
                  </div>
                </div>
                <div className='col-xl-4 col-lg-4'>
                  <div className={mainindexStyle.DesktopbenefitBoxes}>
                    <div className={mainindexStyle.DesktopbenefitimageBox}>
                      <img src={benefittwo} className={`${mainindexStyle.DesktopbenefitImage} w-100 h-100`} />
                    </div>
                    <div className={mainindexStyle.DesktopbenefitContent}>
                      <h5> Authors </h5>
                      <h6> Expand Your Reach and Connect with Readers </h6>
                      <p> Authors can promote their work, share new releases, and engage with a wide range of audiences through AuthorMeet.  Whether you're offering workshops, virtual Q&A sessions, or live readings, the platform provides a seamless way to connect with event hosts and interact with readers.</p>
                    </div>
                  </div>
                </div>
                <div className='col-xl-4 col-lg-4'>
                  <div className={mainindexStyle.DesktopbenefitBoxes}>
                    <div className={mainindexStyle.DesktopbenefitimageBox}>
                      <img src={benefitthree} className={`${mainindexStyle.DesktopbenefitImage} w-100 h-100`} />
                    </div>
                    <div className={mainindexStyle.DesktopbenefitContent}>
                      <h5> Publishers </h5>
                      <h6> Empower Your Authors with New Opportunities </h6>
                      <p> Publishers can leverage AuthorMeet to connect their authors with event hosts, increasing visibility and book sales. Our platform makes it easy to facilitate speaking engagements, allowing your authors to build stronger connections with their audience.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isMobile ? (
          <footer className={mainindexStyle.mobilfooterpart}>
            <div className='container'>
              <div className='row'>
                <a href="/" className='col-lg-12'>
                  <div className={`${mainindexStyle.mobilfooterlogo} d-flex align-items-start justify-content-center`}>
                    <img src={logo} className="img-fluid" />
                    <div className={mainindexStyle.footerbrandTitles}>
                      <h6>AuthorMeet</h6>
                      <p>Powered by: Bookworm Central</p>
                    </div>
                  </div>
                </a>
                <div className='col-lg-12'>
                  <div className={mainindexStyle.Mobilfootermidtext}>
                    <p>Connects readers with authors, offering personalized book purchases, live events, and meaningful
                      interactions that bring stories to life.
                    </p>
                    <h6>Contact Us: outreach@bookwormcentral.com </h6>
                  </div>
                </div>
                <div className='col-lg-12'>
                  <div className={`${mainindexStyle.mobilsocialIcons} d-flex justify-content-center`}>
                    <Link className={`${mainindexStyle.mobilsocialBoxes} me-2 d-flex align-items-center justify-content-center`}>
                      <FaFacebookF className={mainindexStyle.mobilsocialsingleIcon} />
                    </Link>
                    <Link className={`${mainindexStyle.mobilsocialBoxes} me-2 d-flex align-items-center justify-content-center`}>
                      <FaInstagram className={mainindexStyle.mobilsocialsingleIcon} />
                    </Link>
                    <Link className={`${mainindexStyle.mobilsocialBoxes} me-2 d-flex align-items-center justify-content-center`}>
                      <FaSquareXTwitter className={mainindexStyle.mobilsocialsingleIcon} />
                    </Link>
                    <Link className={`${mainindexStyle.mobilsocialBoxes} d-flex align-items-center justify-content-center`}>
                      <FaPinterest className={mainindexStyle.mobilsocialsingleIcon} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        ) : (
          <footer className={mainindexStyle.Desktopfooterpart}>
            <div className='container'>
              <div className='row'>
                <a href="/" className='col-lg-3'>
                  <div className={`${mainindexStyle.Desktopfooterlogo} h-100 d-flex align-items-center justify-content-start`}>
                    <img src={logo} className="img-fluid" />
                    <div className={mainindexStyle.desktopfooterbrandTitles}>
                      <h6>AuthorMeet</h6>
                      <p>Powered by: Bookworm Central</p>
                    </div>
                  </div>
                </a>
                <div className='col-lg-3'>
                  <div className={`${mainindexStyle.desktopfooterleft} h-100 d-flex align-items-center justify-content-start`}>
                    <div className={mainindexStyle.Desktopfootermidtext}>
                      <p> Connects readers with authors, offering personalized book purchases, live events, and
                        meaningful interactions that bring stories to life.
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-lg-6'>
                  <div className={`${mainindexStyle.desktopfooterright} h-100 d-flex align-items-end flex-column`}>
                    <div className={`${mainindexStyle.desktopsocialIcons} d-flex align-items-center justify-content-end mb-3`}>
                      <h4 className='me-3'> Connect with us: </h4>
                      <Link className={`${mainindexStyle.desktopsocialBoxes} ${mainindexStyle.desktopsocialcolorOne} me-2 d-flex align-items-center justify-content-center`}>
                        <FaFacebookF className={mainindexStyle.desktopsocialsingleIcon} />
                      </Link>
                      <Link className={`${mainindexStyle.desktopsocialBoxes} ${mainindexStyle.desktopsocialcolorTwo} me-2 d-flex align-items-center justify-content-center`}>
                        <FaInstagram className={mainindexStyle.desktopsocialsingleIcon} />
                      </Link>
                      <Link className={`${mainindexStyle.desktopsocialBoxes} ${mainindexStyle.desktopsocialcolorThree} me-2 d-flex align-items-center justify-content-center`}>
                        <FaSquareXTwitter className={mainindexStyle.desktopsocialsingleIcon} />
                      </Link>
                      <Link className={`${mainindexStyle.desktopsocialBoxes} ${mainindexStyle.desktopsocialcolorFour} d-flex align-items-center justify-content-center`}>
                        <FaPinterest className={mainindexStyle.desktopsocialsingleIcon} />
                      </Link>
                    </div>
                    <div className={mainindexStyle.desktopfootermailId}>
                      <h6> Contact Us: <span className='ms-4'> outreach@bookwormcentral.com </span></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        )}
      </div>
    </>
  )
}
